// extracted by css-extract-rspack-plugin
export default {"ToggleRoot":"AGRb9","ToggleContent":"xMTy2","isReadOnly":"jE6Oa"};